import * as tslib_1 from "tslib";
import * as React from 'react';
import omit from 'lodash/omit';
import cn from 'astro-classname';
import '../input/index.css';
var BLACK_LIST = [
    'className',
    'width',
    'prefix',
    'autoFocus',
    'onPressEnter',
    'theme'
];
var TextArea = (function (_super) {
    tslib_1.__extends(TextArea, _super);
    function TextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDown = function (e) {
            var _a = _this.props, onKeyDown = _a.onKeyDown, onPressEnter = _a.onPressEnter;
            if (onKeyDown) {
                onKeyDown(e);
            }
            if (e.keyCode === 13 && onPressEnter) {
                onPressEnter(e);
            }
        };
        _this.saveTextArea = function (textarea) {
            _this.textarea = textarea;
        };
        return _this;
    }
    TextArea.prototype.componentDidMount = function () {
        var autoFocus = this.props.autoFocus;
        if (autoFocus) {
            this.textarea.focus();
        }
    };
    TextArea.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, width = _b.width, prefix = _b.prefix, disabled = _b.disabled, theme = _b.theme;
        var classes = cn(prefix + "-textarea", (_a = {},
            _a[prefix + "-disabled"] = disabled,
            _a[prefix + "-" + theme] = theme && theme !== 'default',
            _a));
        var nodeProps = omit(this.props, BLACK_LIST);
        return (React.createElement("div", { className: cn(prefix + "-textarea-wrapper", className), style: { width: width } },
            React.createElement("textarea", tslib_1.__assign({ ref: this.saveTextArea, className: classes, onKeyDown: this.handleKeyDown }, nodeProps))));
    };
    TextArea.defaultProps = {
        className: '',
        prefix: 'zhui-input',
        disabled: false,
        autoFocus: false
    };
    return TextArea;
}(React.Component));
export default TextArea;
